import { useState } from 'react'
import LogoManrina from './components/LogoManrina'

// === ICONS SVG ===
const icons = {
  dashboard: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
    </svg>
  ),
  caisse: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  marche: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
    </svg>
  ),
  tournees: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
    </svg>
  ),
  produits: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </svg>
  ),
  facturation: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z" />
    </svg>
  ),
  utilisateurs: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  ),
  notifications: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
  ),
  admin: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  logout: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
    </svg>
  ),
  refresh: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
  ),
  transformation: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
    </svg>
  ),
  lavwa: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
    </svg>
  ),
  tanbou: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <ellipse cx="12" cy="6" rx="7" ry="2.5" strokeWidth={1.8} />
      <path strokeLinecap="round" strokeWidth={1.8} d="M5 6v6c0 1.38 3.134 2.5 7 2.5s7-1.12 7-2.5V6" />
      <path strokeLinecap="round" strokeWidth={1.8} d="M7.5 14.2L5 20m11.5-5.8L19 20" />
    </svg>
  ),
  fonds: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <ellipse cx="12" cy="6" rx="7" ry="2.5" strokeWidth={1.8} />
      <path strokeLinecap="round" strokeWidth={1.8} d="M5 6v5c0 1.38 3.134 2.5 7 2.5s7-1.12 7-2.5V6" />
      <path strokeLinecap="round" strokeWidth={1.8} d="M5 11v5c0 1.38 3.134 2.5 7 2.5s7-1.12 7-2.5v-5" />
    </svg>
  ),
  more: (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
    </svg>
  ),
}

// === NAV ITEMS ===
const NAV_ITEMS = [
  { id: 'dashboard', label: 'Accueil', icon: 'dashboard' },
  { id: 'caisse', label: 'Caisse', icon: 'caisse' },
  { id: 'marche', label: 'Evenements', icon: 'marche' },
  { id: 'tournees', label: 'Tournees', icon: 'tournees' },
  { id: 'transformation', label: 'Transformation', icon: 'transformation' },
  { id: 'lavwa', label: 'Lavwa', icon: 'lavwa', adminOnly: true },
  { id: 'tanbou', label: 'Tanbou', icon: 'tanbou', adminOnly: true },
  { id: 'fonds', label: 'Réserve', icon: 'fonds', adminOnly: true },
  { id: 'facturation', label: 'Comptabilité', icon: 'facturation', adminOnly: true },
  { id: 'produits', label: 'Produits', icon: 'produits', adminOnly: true },
  { id: 'utilisateurs', label: 'Utilisateurs', icon: 'utilisateurs', adminOnly: true },
  { id: 'notifications', label: 'Notifications', icon: 'notifications', adminOnly: true },
  { id: 'admin', label: 'Admin', icon: 'admin', adminOnly: true },
]

// Mobile bottom nav shows only first 4 + more
const MOBILE_NAV = ['dashboard', 'caisse', 'marche', 'tournees']

async function handleForceUpdate() {
  try {
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k)))
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister()))
    }
  } catch { /* ignore */ }
  // Cache-buster query param pour forcer le navigateur a re-fetcher index.html
  const url = new URL(window.location.href)
  url.searchParams.set('_v', Date.now().toString())
  window.location.replace(url.toString())
}

export default function Layout({ activeModule, onSelect, currentUser, onLogout, children }) {
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  const isAdmin = currentUser?.role === 'ADMIN'
  const visibleNav = NAV_ITEMS.filter(n => !n.adminOnly || isAdmin)
  const moreItems = visibleNav.filter(n => !MOBILE_NAV.includes(n.id))

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* === SIDEBAR DESKTOP === */}
      <aside className={`hidden md:flex flex-col fixed top-0 left-0 h-full z-40 transition-all duration-300 ${sidebarCollapsed ? 'w-[68px]' : 'w-56'}`}>
        <div className="flex flex-col h-full glass-dark border-r border-white/10">
          {/* Logo */}
          <div className="p-4 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-manrina-500/20 flex items-center justify-center flex-shrink-0">
              <LogoManrina className="w-7 h-7" emojiClassName="text-xl" />
            </div>
            {!sidebarCollapsed && (
              <div>
                <h1 className="font-display font-bold text-white text-lg leading-tight">Manrina</h1>
                <p className="text-[10px] text-white/40 uppercase tracking-wider">Backoffice</p>
              </div>
            )}
          </div>

          {/* Nav */}
          <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto scrollbar-thin">
            {visibleNav.map(item => {
              const active = activeModule === item.id
              return (
                <button
                  key={item.id}
                  onClick={() => onSelect(item.id)}
                  title={sidebarCollapsed ? item.label : undefined}
                  className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all ${
                    active
                      ? 'bg-manrina-500/20 text-manrina-400'
                      : 'text-white/60 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <span className={active ? 'text-manrina-400' : ''}>{icons[item.icon]}</span>
                  {!sidebarCollapsed && <span>{item.label}</span>}
                </button>
              )
            })}
          </nav>

          {/* Footer sidebar */}
          <div className="p-3 border-t border-white/10 space-y-1">
            <button
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-white/40 hover:text-white/70 hover:bg-white/5 text-sm transition-all"
            >
              <svg className={`w-5 h-5 transition-transform ${sidebarCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
              </svg>
              {!sidebarCollapsed && <span>Reduire</span>}
            </button>
            <button
              onClick={handleForceUpdate}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-white/40 hover:text-emerald-400 hover:bg-emerald-500/10 text-sm transition-all"
              title="Force la mise a jour de l'app (vide le cache + recharge)"
            >
              {icons.refresh}
              {!sidebarCollapsed && <span>Mettre a jour</span>}
            </button>
            <button
              onClick={onLogout}
              className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-white/40 hover:text-red-400 hover:bg-red-500/10 text-sm transition-all"
            >
              {icons.logout}
              {!sidebarCollapsed && <span>Deconnexion</span>}
            </button>
          </div>
        </div>
      </aside>

      {/* === MAIN CONTENT === */}
      {/* min-w-0 + overflow-x-hidden : empeche un enfant qui deborde de pousser
          le main au-dela du viewport. Sans ca, un flex/grid mal dimensionne fait
          tout deborder a droite (chips coupes, header onglets coupe, FAB cache).
          Note : transition uniquement sur margin-left (pas `all`) car `transition: all`
          peut creer un containing block sur Safari iPhone et casser position:fixed
          des FABs enfants. */}
      <main className={`flex-1 min-w-0 overflow-x-hidden md:transition-[margin] md:duration-300 ${sidebarCollapsed ? 'md:ml-[68px]' : 'md:ml-56'} pb-20 md:pb-0`}>
        {/* Header mobile */}
        <header className="md:hidden sticky top-0 z-30 glass border-b border-gray-200/50">
          <div className="flex items-center px-4 py-3">
            <div className="flex items-center gap-2">
              <LogoManrina className="w-6 h-6" emojiClassName="text-xl" />
              <span className="font-display font-bold text-nature-800">Manrina</span>
            </div>
          </div>
        </header>

        {/* Page content */}
        <div className="animate-fade-up">
          {children}
        </div>
      </main>

      {/* === BOTTOM NAV MOBILE === */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass border-t border-gray-200/50">
        <div className="flex items-center justify-around px-2 py-1">
          {MOBILE_NAV.map(id => {
            const item = NAV_ITEMS.find(n => n.id === id)
            const active = activeModule === id
            return (
              <button
                key={id}
                onClick={() => { onSelect(id); setMobileMoreOpen(false) }}
                className={`flex flex-col items-center gap-0.5 py-2 px-3 rounded-xl transition-all ${
                  active
                    ? 'text-manrina-500'
                    : 'text-gray-400'
                }`}
              >
                {icons[item.icon]}
                <span className="text-[10px] font-medium">{item.label}</span>
              </button>
            )
          })}

          {/* More button */}
          <div className="relative">
            <button
              onClick={() => setMobileMoreOpen(!mobileMoreOpen)}
              className={`flex flex-col items-center gap-0.5 py-2 px-3 rounded-xl transition-all ${
                mobileMoreOpen || moreItems.some(i => i.id === activeModule)
                  ? 'text-manrina-500'
                  : 'text-gray-400'
              }`}
            >
              {icons.more}
              <span className="text-[10px] font-medium">Plus</span>
            </button>

            {/* More dropdown */}
            {mobileMoreOpen && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setMobileMoreOpen(false)} />
                <div className="absolute bottom-14 right-0 z-50 glass rounded-2xl shadow-xl border border-gray-200/50 py-2 min-w-[180px]">
                  {moreItems.map(item => {
                    const active = activeModule === item.id
                    return (
                      <button
                        key={item.id}
                        onClick={() => { onSelect(item.id); setMobileMoreOpen(false) }}
                        className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition ${
                          active
                            ? 'text-manrina-500 bg-manrina-50'
                            : 'text-gray-600 hover:bg-gray-50'
                        }`}
                      >
                        {icons[item.icon]}
                        <span>{item.label}</span>
                      </button>
                    )
                  })}
                  <div className="border-t border-gray-200/50 mt-1 pt-1">
                    <button
                      onClick={() => { setMobileMoreOpen(false); handleForceUpdate() }}
                      className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-emerald-600 hover:bg-emerald-50 transition"
                    >
                      {icons.refresh}
                      <span>Mettre a jour</span>
                    </button>
                    <button
                      onClick={() => { onLogout(); setMobileMoreOpen(false) }}
                      className="w-full flex items-center gap-3 px-4 py-3 text-sm font-medium text-red-500 hover:bg-red-50 transition"
                    >
                      {icons.logout}
                      <span>Deconnexion</span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </nav>
    </div>
  )
}
